import { Component, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NwbAlertService } from '@wizishop/ng-wizi-bulma';
import { DataService } from '../../services/data.service';
import { AlertPosition, AlertDuration, AlertDurationWithRedirect } from 'src/app/shared/constant.shared';
import { createAlertConfig } from 'src/app/shared/factoryconfigAlert';
import { Router } from '@angular/router';

@Component({
  selector: 'add-amico-fedele',
  templateUrl: './add-amico-fedele.component.html',
  styleUrls: ['./add-amico-fedele.component.css']
})
/** addAmicoFedele component*/
export class AddAmicoFedeleComponent {

  @ViewChild('assignAmicoFedeleForm', { static: true })
  formSendAssign: NgForm;

  @ViewChild('addAmicoFedeleForm', { static: true })
  formSendAdd: NgForm;

  idSocio: number;
  chip: string;

  amicoFedele: any;

  /** addSocioGroup ctor */
  constructor(@Inject(LOCALE_ID) public locale: string, private dataService: DataService, private alertservice: NwbAlertService, private router: Router) {
    this.amicoFedele = {};
  }

  assignAmicoFedele() {
    if (this.formSendAssign.invalid) return;

    if (this.idSocio < 1 || this.idSocio > 2147483647) {
      this.alertservice.open(createAlertConfig("Id socio non valido", false)).afterClosed().subscribe();
      return;
    }

    this.dataService.assignAmicoFedele(this.idSocio, this.chip).subscribe(() => {
      this.alertservice.open(createAlertConfig("amico fedele assegnato", true, AlertDurationWithRedirect)).afterClosed().subscribe(() => {
        this.router.navigate(['/area-utente', 'gruppo']);
      });
    }, (error) => {

      if (error.error) {
        switch (error.error) {
          case "not_exist":
            if (this.locale == 'it') {
              this.alertservice.open(createAlertConfig("Amico fedele non esistente. Se vuoi crearne uno usa il form sottostante", false)).afterClosed().subscribe();
            } else {
              this.alertservice.open(createAlertConfig("Dog not exist. If you want to create one use the form below", false)).afterClosed().subscribe();
            }
            break;
          case "dog_another_owner":
            if (this.locale == 'it') {
              this.alertservice.open(createAlertConfig("L'amico fedele ha un altro proprietario", false)).afterClosed().subscribe();
            } else {
              this.alertservice.open(createAlertConfig("Dog has another owner", false)).afterClosed().subscribe();
            }
            break;
          case "deactivated":
            if (this.locale == 'it') {
              this.alertservice.open(createAlertConfig("Amico fedele disabilitato", false)).afterClosed().subscribe();
            } else {
              this.alertservice.open(createAlertConfig("Dog deactivated", false)).afterClosed().subscribe();
            }
            break;

        }
      } else {
        if (this.locale == 'it') {
          this.alertservice.open(createAlertConfig("Errore non gestito. Provare a ricaricare la pagina. Se persiste contattare l'assistenza", false)).afterClosed().subscribe();
        } else {
          this.alertservice.open(createAlertConfig("Error not manage. Try to reload the current page. If persist contact the support", false)).afterClosed().subscribe();
        }
      }


    });
  }

  addAmicoFedele() {
    if (this.formSendAdd.invalid) return;
    this.dataService.addAmicoFedele(this.amicoFedele).subscribe(() => {
      this.alertservice.open(createAlertConfig("amico fedele aggiunto", true, AlertDurationWithRedirect)).afterClosed().subscribe(() => {

        this.router.navigate(['/area-utente', 'gruppo']);
      });
    });
  }
}
